import React from 'react';
import BaseModal from 'src/components/BaseModal/BaseModal';
import { StoryboardViewer, StoryboardViewerProps } from './StoryboardViewer';

/** The viewer in the app's standard dialog, sized for a frame grid. */
export const StoryboardViewerModal: React.FC<StoryboardViewerProps> = (props) => (
  <BaseModal containerStyle={{ width: 'min(1100px, 94vw)' }}>
    <StoryboardViewer {...props} />
  </BaseModal>
);

export default StoryboardViewerModal;
